import { Page } from '../types/app';

export const LOGIN_PAGE: Page = {
  id: 'login',
  name: 'Inicio de sesión',
  route: '/login',
};
export const NOT_FOUND_PAGE: Page = {
  id: '404',
  name: 'Página no encontrada',
  route: '/*',
};
export const SERVER_ERROR_PAGE: Page = {
  id: '500',
  name: 'Error del servidor',
  route: '/500',
};

export const USERS_PAGE: Page = {
  id: 'users',
  name: 'Usuarios',
  route: '/usuarios',
  icon: 'group',
  navKey: 'users',
};
export const CLIENTS_PAGE: Page = {
  id: 'tenants',
  name: 'Clientes',
  route: '/configuracion/clientes',
  icon: 'group_work',
  navKey: 'tenants',
};
export const COMPANIES_PAGE: Page = {
  id: 'companies',
  name: 'Compañias',
  route: '/configuracion/companias',
  icon: 'apartment',
  navKey: 'companies',
};
export const JOBS_PAGE: Page = {
  id: 'jobs',
  name: 'Trabajos',
  route: '/trabajos',
  icon: 'description',
  navKey: 'jobs',
};
export const JOBS_CALENDAR_PAGE: Page = {
  id: 'jobsCalendar',
  name: 'Calendario',
  route: '/calendario',
  icon: 'calendar_clock',
  navKey: 'jobsCalendar',
};
export const JOBS_SKILLS_PAGE: Page = {
  id: 'skills',
  name: 'Habilidades',
  route: '/configuracion/habilidades',
  icon: 'handyman',
  navKey: 'skills',
};
export const JOBS_TYPES_PAGE: Page = {
  id: 'jobTypes',
  name: 'Tipos de trabajos',
  route: '/configuracion/tipos',
  icon: 'description',
  navKey: 'jobTypes',
};
export const JOB_TYPE_PAGE: Page = {
  id: 'jobType',
  name: 'Tipo de trabajo',
  route: '/configuracion/tipo/:jobTypeId',
  icon: 'description',
  navKey: 'jobType',
  breadcrumb: {
    defaultPath: JOBS_TYPES_PAGE.route,
    title: JOBS_TYPES_PAGE.name,
  },
  parentId: 'jobTypes',
};

export const FORMS_PAGE: Page = {
  id: 'forms',
  name: 'Formularios',
  route: '/formularios',
  icon: 'assignment_turned_in',
  navKey: 'forms',
};

export const ALL_PAGES: Page[] = [
  LOGIN_PAGE,
  NOT_FOUND_PAGE,
  SERVER_ERROR_PAGE,
  USERS_PAGE,
  JOBS_PAGE,
  JOBS_CALENDAR_PAGE,
  CLIENTS_PAGE,
  COMPANIES_PAGE,
  JOBS_SKILLS_PAGE,
  JOBS_TYPES_PAGE,
  JOB_TYPE_PAGE,
  FORMS_PAGE,
];

export const CORE_PAGE_IDS = [USERS_PAGE.id, JOBS_PAGE.id, JOBS_CALENDAR_PAGE.id];
export const CHILDREN_CORE_PAGE_IDS: string[] = [];

export const SETTINGS_PAGE_ID = 'settings';
export const SETTINGS_PAGE_IDS = [
  CLIENTS_PAGE.id,
  COMPANIES_PAGE.id,
  JOBS_SKILLS_PAGE.id,
  JOBS_TYPES_PAGE.id,
  FORMS_PAGE.id,
];
export const CHILDREN_SETTINGS_PAGE_IDS = [JOB_TYPE_PAGE.id];

export const SMALL_LIST_ITEM_HEIGHT = 50;
export const DEFAULT_LIST_ITEM_HEIGHT = 65;
export const LARGE_LIST_ITEM_HEIGHT = 80;
export const EXTRA_LARGE_LIST_ITEM_HEIGHT = 100;

export const SIDENAV_WIDTH = 76;
export const EXPANDED_SIDENAV_WIDTH = 200;

export const LIST_CARD_WIDTH = 300;
export const ASIDE_WIDTH = 400;

export const MIN_WIDTH_MAP = '400px';
export const MIN_HEIGHT_MAP = '220px';
export const DATA_WIDTH = '280px';
export const DATA_XL_WIDTH = '560px';

export const FEEDBACK = {
  created: (prefix: string) => `${prefix} se creo con éxito.`,
  added: (prefix: string) => `${prefix} se añadio con éxito.`,
  edited: (prefix: string, name: string = '') => `${prefix} "${name}" se actualizo correctamente.`,
  deleted: (prefix: string, name: string = '') => `Se eliminó ${prefix.toLowerCase()} "${name}" correctamente.`,
  remove: (prefix: string, name: string = '') => `Se removio ${prefix.toLowerCase()} "${name}" correctamente.`,
  failedFetch: (prefix: string) => `Ocurrió un error al obtener ${prefix.toLowerCase()}, inténtalo nuevamente.`,
  failedCreation: (prefix: string) => `Ocurrió un error al crear ${prefix.toLowerCase()}, inténtalo nuevamente.`,
  failedEdition: (prefix: string, name: string = '') =>
    `Ocurrió un error al editar ${prefix.toLowerCase()} ${name}, inténtalo nuevamente.`,
  failedDeletion: (prefix: string, name: string = '') =>
    `Ocurrió un error al eliminar ${prefix.toLowerCase()} ${name}, inténtalo nuevamente.`,
};

export const FEEDBACK_PREFIXES = {
  user: 'El usuario',
  job: 'El trabajo',
  jobSkill: 'La habilidad',
  jobType: 'El tipo',
  jobActivity: 'La actividad',
  jobSchedule: 'La cita del trabajo',
  tenant: 'El cliente',
  form: 'El formulario',
  formField: 'El campo',
  pdfSettings: 'La configuración del pdf',
  company: 'La compañia',
  overprice: 'El sobreprecio',
  expenses: 'Los viáticos',
};

export const REQUIRED_FIELD_TEXT = 'Este campo es requerido';
export const VELID_FIELD_TEXT = (example?: string, rangeExample?: string) =>
  `Ingrese un valor valido${example ? ', ejemplo: ' + example : rangeExample ? ', entre ' + rangeExample : ''}.`;

export const FILE_TYPE_IMAGE = 'image';
export const FILE_TYPE_DOCUMENT = 'document';
